import ImageOnly from './ImageOnly';
import ImageText from './ImageText';
import ImageTextLeft from './ImageTextLeft';
import TextOnly from './TextOnly';
export var COMPONENTS = {
  IMAGE_ONLY: {
    component: ImageOnly
  },
  IMAGE_TEXT_LEFT: {
    component: ImageTextLeft
  },
  IMAGE_TEXT: {
    component: ImageText
  },
  LONG: {
    component: ImageText,
    props: {
      ratio4x1: true
    }
  },
  TEXT_ONLY: {
    component: TextOnly
  }
};
export var genderURLs = {
  Women: '/collections/shop-women',
  Men: '/collections/shop-men'
};
export var fabricsURL = '/pages/materials';